<div class="overlay3"
     (click)="onClose()"></div>

<div class="popup-wrap">

  <div class="popup-head">
    <div class="head-txt-box">사 성 옥편 도움말</div>
    <a class="popup-close-btn" (click)="onClose()"></a>
  </div>

  <div class="help-body-container scroll-effect"
       [style.max-height.px]="calculatedHeight">
  <!-- <div class="help-body-container scroll-effect" style="overflow: hidden;"> -->
    <div class="popup-body">

      <div class="help-txt-box">

        <div class="saseung-container">
          <div class="crow">
            <div class="cell first">1.</div>
            <div class="cell end">일제시대에 사용을 하도록 한 '한자<span class="hanja-size">漢子</span>'를 본시 우리가 쓰던 대로, '문자<span class="hanja-size">文字</span>'라고 칭합니다.</div>
          </div>
        </div>

        <div class="saseung-container">
          <div class="crow">
            <div class="cell first">2.</div>
            <div class="cell end">본 사 성 옥편에 {{ characterTotalCount | number }}개의 문자가 수록되어 있고, {{ toneMarkedCharacterCount | number }}개의 문자에는 성조가 표기 되어 있으나 그 외의 문자에는 성조를 표기 하지 않았습니다. 또 두 가지의 성조가 쓰이는 문자는 두 가지를 병기 하였고 이 경우는 앞에 적힌 성조가 주된 성조입니다.</div>
          </div>
        </div>

        <div class="saseung-container">
          <div class="crow">
            <div class="cell first">3.</div>
            <div class="cell end">문자에는 여러 훈(뜻)이 적용될 수 있으나, 소통을 위해 대표 훈을 성조 옆에 적어서 이를 알렸습니다.</div>
          </div>
        </div>

        <div class="saseung-container">
          <div class="crow">
            <div class="cell first">4.</div>
            <div class="cell end">한 문자에 여러 문자가 적힌 것은 본 문자의 동자, 속자, 간자입니다.</div>
          </div>
        </div>

      </div>

      <div class="help-saseung-box">
        <div class="header cell">한국어 성조</div>
        <div class="header cell">수자<span class="hanja-size">數字</span><br>표지</div>
        <div class="header cell">색상 표지</div>
        <div class="header cell">기호 표지</div>

        <div class="cell"><span class="left">고 평성<span class="hanja-size">高平聲</span></span></div>
        <div class="cell"><span>5</span></div>
        <div class="cell"><div class="type-3 seungjo-5"></div></div>
        <div class="cell"><div class="type-1 seungjo-5"></div></div>

        <div class="cell"><span class="left">미끄러지는 소리</span></div>
        <div class="cell"><span>4</span></div>
        <div class="cell"><div class="type-3 seungjo-4"></div></div>
        <div class="cell"><div class="type-1 seungjo-4"></div></div>

        <div class="cell"><span class="left">거성<span class="hanja-size">去聲</span></span></div>
        <div class="cell"><span>3</span></div>
        <div class="cell"><div class="type-3 seungjo-3"></div></div>
        <div class="cell"><div class="type-1 seungjo-3"></div></div>

        <div class="cell"><span class="left">상성<span class="hanja-size">上聲</span></span></div>
        <div class="cell"><span>2</span></div>
        <div class="cell"><div class="type-3 seungjo-2"></div></div>
        <div class="cell"><div class="type-1 seungjo-2"></div></div>

        <div class="cell"><span class="left">저 평성<span class="hanja-size">低平聲</span></span></div>
        <div class="cell"><span>1</span></div>
        <div class="cell"><div class="type-3 seungjo-1"></div></div>
        <div class="cell"><div class="type-1 seungjo-1"></div></div>
      </div>

      <div class="help-comment-box"> ※ 자세한 설명은 ‘베풀기’ 참조 요망 </div>

    </div>
  </div>

    <div class="question-box">
      <div>&nbsp;</div>
      <div class="question-btn-box">
        <a class="question-btn type1"
        [routerLink]="['/board', BBS_CATEGORY.USAGE, SASEUNG_HELP_BBS_ID]">자세히 보기</a>
      </div>
    </div>

    <!-- <div class="foot-menu-box">
      <a class="foot-menu-btn type-1"
         [routerLink]="['/board', BBS_CATEGORY.USAGE]"
         [queryParams]="{ id: SASEUNG_HELP_BBS_ID }">자세히 보기</a>
    </div> -->

</div>
